export default __webpack_public_path__ + "media/images/casatb/tenant/how-to-rent-five-f731eb1dd5d4d62e001112dcadf674dc.png";